import React from "react";
import classnames from "classnames";

import { Brand } from "custom-types/Brand";

import ExpandableContainer from "components/botanic/ExpandableContainer";
import BrandLicenses from "components/brands/BrandLicenses";
import { FormattedText } from "components/FormattedText";

import MiniBrandHeader from "./MiniBrandHeader";

const BrandInfoSection = ({
  brand,
  includeMiniHeader,
}: {
  brand: Brand;
  includeMiniHeader?: boolean;
}) => {
  // Even if you have added a video, you Must have a brand description to show this section
  if (!brand.description) {
    return null;
  }

  // TODO update this condition when we add spotlight text field
  const hasTwoCols = brand.spotlightVideoEmbedUrl;

  return (
    <>
      <div className="container mb-xl" data-testid="about-brand">
        <div className="md:flex">
          <div
            className={classnames("md:flex-auto", {
              justDescription: !hasTwoCols,
            })}
          >
            <h2 className="mb-sm">About this brand</h2>
            {includeMiniHeader && (
              <MiniBrandHeader brand={brand} className="mb-lg" />
            )}
            <ExpandableContainer autoHide initialHeight="312px">
              <FormattedText text={brand.description} />
            </ExpandableContainer>
            {!!brand.brandLicenses?.length && (
              <BrandLicenses brandLicenses={brand.brandLicenses} />
            )}
          </div>
          {hasTwoCols && (
            <div className="md:ml-lg md:mt-none mt-lg">
              <h2 className="mb-sm">Brand Spotlight</h2>
              <iframe
                src={brand.spotlightVideoEmbedUrl}
                frameBorder="0"
                title="Brand spotlight video"
                className="embedYt mt-xs"
              ></iframe>
            </div>
          )}
        </div>
      </div>
      <style jsx>{`
        .embedYt {
          width: 328px;
          height: 185px;
        }

        @media only screen and (min-width: 768px) {
          .embedYt {
            width: 416px;
            height: 234px;
          }

          /* when there is only 1 column on desktop, limit width */
          .justDescription {
            max-width: 66%;
          }
        }
      `}</style>
    </>
  );
};

export default BrandInfoSection;
